import { render } from "./recomendadoComponent.vue?vue&type=template&id=125a48ae"
import script from "./recomendadoComponent.vue?vue&type=script&lang=js"
export * from "./recomendadoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__